import type {
  PublicClientApplication,
  SilentRequest,
} from '@azure/msal-browser';

// Store values internally
let _msalInstance: PublicClientApplication | null = null;
let _apiRequest: SilentRequest | null = null;

// Configure MSAL instance + default API request
export const setAuthConfig = (
  instance: PublicClientApplication,
  apiReq: SilentRequest
): void => {
  _msalInstance = instance;
  _apiRequest = apiReq;
};

// Safe getter for MSAL instance
export const getMsalInstance = (): PublicClientApplication | null =>
  _msalInstance;

// Safe getter for API request config
export const getApiRequest = (): SilentRequest | null => _apiRequest;
